import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { zipSync, strToU8 } from 'fflate';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { theme, DatePicker, Tooltip, Modal } from 'antd';
import { AppDispatch, RootState } from 'store/configureStore';
import TitleBar from 'components/TitleBar';
import { useLocation } from 'react-router-dom';
import CustomSelect from 'components/CustomSelect';
import { TitleList } from 'store/ducks/globalTypes';
import qs from 'qs';
import ReportModal from 'components/Modal/Modal';
import { tableData, tableMappings } from 'constants/excelData';
import useFilters from 'utils/hooks/useFilters';
import { globalOp } from 'store/ducks/Global';
import { reportingOp } from 'store/ducks/Reportings';
import {
  set_selectedDate,
  set_isDisplayed,
} from 'store/ducks/Reportings/reportingSlice';
import dora from './report.json';
import { displayTitleMap } from 'constants/reportTitles';
import { exportToExcel } from 'utils/hooks/excelUtils99';
import { entityOp } from 'store/ducks/DataEntry/Entities';
import { set_idOfSelectedFinancialEntity } from 'store/ducks/DataEntry/Entities/entitySlice';
import { set_filters_data_lei } from 'store/ducks/Global/globalSlice';
import { ReportingHoverStyle } from 'components/Tables/Reporting/Reporting.styled';
import { TableItem } from 'store/ducks/Reportings/types';
import * as Styled from '../Layout.styled';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';

const { useToken } = theme;

const ReportingLayout: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { token } = useToken();
  const { t } = useTranslation();
  const { scheme } = useSelector((state: RootState) => state.global);
  const { date } = useSelector((state: RootState) => state.reportings);
  const [dataReports99, setDataReports99] = useState<any>({});
  const [selectedItem, setSelectedItem] = useState<TableItem | null>(null);
  const [combinedData, setCombinedData] = useState<any[]>([]);
  const [transposedArrays, setTransposedArrays] = useState<any[][]>([]);
  const [entityMaintaining, setEntityMaintaining] = useState<any[]>([]);
  const [selectedReportType, setSelectedReportType] = useState('');
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [modalReportTypeVisble, setModalReportTypeVisible] = useState(false);
  const { idOfSelectedFinancialEntity } = useSelector(
    (state: RootState) => state.entities,
  );
  const [selectedEntities, setSelectedEntities] = React.useState<number[]>([]);
  const { queryLei, handleFilterChangeForReportingsLei } = useFilters();
  const [currencies, setCurrencies] = useState<
    { label: string; value: string }[]
  >([]);
  const entitiesByLei = useSelector(
    (state: RootState) => state.global.filtersDataLei,
  );

  const handleChangeFinancialEntity = (selectedOption: any) => {
    dispatch(set_idOfSelectedFinancialEntity(selectedOption));
    dispatch(set_filters_data_lei(selectedOption));
  };

  // const processData = (apiData: any) => {
  //   if (!apiData) {
  //     return [];
  //   }

  //   const formattedData: any[] = [];
  //   let rowIndex = 0;
  //   let currentRTIndex = 0;
  //   let remainingRowspan = columnCodes[currentRTIndex]?.rowspan || 0;

  //   Object.entries(apiData).forEach(([key, values]: [string, any]) => {
  //     values.forEach((item: any, itemIndex: number) => {
  //       const currentRT = columnCodes[currentRTIndex];
  //       const columnName = columnNames[currentRTIndex]?.value || '';
  //       const rtValue =
  //         itemIndex % currentRT.rowspan === 0 ? currentRT.value : '';
  //       const columnHeader =
  //         itemIndex % currentRT.rowspan === 0 ? columnName : '';

  //       formattedData.push([
  //         item.data_point || '',
  //         rtValue,
  //         columnHeader,
  //         item.description || '',
  //         item.int_options_def || '',
  //       ]);

  //       rowIndex++;
  //       remainingRowspan--;

  //       if (remainingRowspan === 0) {
  //         currentRTIndex++;
  //         remainingRowspan = columnCodes[currentRTIndex]?.rowspan || 0;
  //       }
  //     });
  //   });

  //   return formattedData;
  // };

  const fetchEntityMaintaining = async () => {
    try {
      const response = await entityOp.fetchAllFinancialEntities();
      const data = response?.data;
      if (data.length > 0) {
        const updatedTPPData = data.map((item: any, index: number) => ({
          key: index,
          id: item.id,
          financial_entity_name: item.financial_entity_name,
        }));
        setEntityMaintaining(updatedTPPData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const response = await entityOp.fetchCurrencies();
      if (response?.data.currencies) {
        const formattedOptions = response.data.currencies.map(
          (reasons: { currency_name: any; id: any }) => ({
            label: reasons.currency_name,
            value: reasons.id,
          }),
        );
        setCurrencies(formattedOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchEntityMaintaining();
  }, []);

  useEffect(() => {
    setSelectedEntities([]);
  }, [idOfSelectedFinancialEntity]);

  useEffect(() => {
    if (selectedEntities.length > 1) {
      setSelectedReportType('CON');
    } else {
      setSelectedReportType('IND');
    }
  }, [selectedEntities]);

  const onChangeStartDate = (
    date: dayjs.Dayjs | null,
    dateString: string | string[],
  ) => {
    if (typeof dateString === 'string') {
      dispatch(set_selectedDate(dateString));
    }
  };
  const location = useLocation();
  const queryParams = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  useEffect(() => {
    if (idOfSelectedFinancialEntity) {
      dispatch(globalOp.setFiltersBylei(idOfSelectedFinancialEntity));
    }
  }, [dispatch, idOfSelectedFinancialEntity]);

  const entityKey = Array.isArray(queryLei.entityId)
    ? queryLei.entityId.sort().join(',')
    : queryLei.entityId;

  useEffect(() => {
    if (entityKey) fetchData();
  }, [entityKey]);

  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const params = {
      entityId: queryLei.entityId,
      date,
    };

    try {
      const fetchedData = await reportingOp.fetchB9901(params);
      const entities = fetchedData?.entities || {};
      const flattenedData: Record<string, any[]> = {};

      Object.values(entities).forEach((entity: any) => {
        const filtered = entity.filtered_data || {};
        Object.keys(filtered).forEach((key) => {
          if (!flattenedData[key]) flattenedData[key] = [];
          const items = filtered[key].map((item: any) => ({
            ...item,
            entity_name: entity.entity_name,
          }));
          flattenedData[key].push(...items);
        });
      });

      setDataReports99(flattenedData);
    } catch (error) {
      console.log('Error fetching data:', error);
      setDataReports99({});
    }
  };

  const downloadCSV = async (
    queryLei: any,
    date: string,
    reportType: string,
    selectedCurrency: string,
  ) => {
    const normalizedEntityIds = Array.isArray(queryLei?.entityId)
      ? queryLei.entityId
      : queryLei?.entityId
        ? [queryLei.entityId]
        : [];

    if (normalizedEntityIds.length === 0) {
      console.warn('No entity selected — aborting CSV generation');
      return;
    }

    const params = { entityId: normalizedEntityIds, date };

    try {
      const results = await Promise.all(
        tableMappings.map(({ fetchFn }) => fetchFn(params).catch(() => null)),
      );

      const files: Record<string, Uint8Array> = {};

      files['META-INF/reportPackage.json'] = strToU8(
        JSON.stringify(
          {
            documentInfo: {
              documentType: 'https://xbrl.org/report-package/2023',
            },
          },
          null,
          2,
        ),
      );

      let leiEntityValue: string | null = null;
      const filingIndicatorRows: string[] = ['templateID;reported'];

      for (let i = 0; i < results.length; i++) {
        const rawData = results[i];
        const { tableNumber } = tableMappings[i];

        const rawHeaders = displayTitleMap[tableNumber] || [];

        const filteredHeaders = rawHeaders
          .map((header: string, index: number) => {
            const trimmed = header.trim();
            if (!trimmed.startsWith('00')) return null;

            const match = trimmed.match(/^(\d+)/);

            return {
              header: trimmed,
              originalIndex: index,
              numericPrefix: match
                ? parseInt(match[1], 10)
                : Number.MAX_SAFE_INTEGER,
            };
          })
          .filter(Boolean as any)
          .sort((a: any, b: any) => a.numericPrefix - b.numericPrefix);

        const headers = filteredHeaders.map((h: any) => h.header);

        let excelData: any[] = [];

        if (Array.isArray(rawData)) {
          excelData = rawData;
        } else if (
          rawData?.filtered_data &&
          Array.isArray(rawData.filtered_data)
        ) {
          excelData = rawData.filtered_data.map((item: any) => ({
            ...item,
            entity_name: rawData.entity_name,
            date: rawData.date || date,
          }));
        } else if (rawData?.entities) {
          const allEntities = Object.values(rawData.entities)
            .flatMap((entity: any) => {
              if (Array.isArray(entity)) return entity;

              if (entity?.filtered_data) {
                return Object.values(entity.filtered_data).flat();
              }

              return [];
            })
            .filter(Boolean);

          excelData = allEntities.map((item: any) => ({
            ...item,
            entity_name: item.entity_name || rawData.entity_name,
            date: rawData.date || date,
          }));
        }

        if (excelData.length === 0) {
          filingIndicatorRows.push(`${tableNumber};false`);
          continue;
        }

        const formattedData = excelData.map((row: Record<string, any>) => {
          const formattedRow: Record<string, any> = {};
          const keys = Object.keys(row);

          filteredHeaders.forEach((item: any) => {
            const header = item.header;

            let value: any;

            if (tableNumber === 'b_03.01') {
              if (
                header === '0010 - Contractual arrangement reference number'
              ) {
                value = row.arrangement_reference_number;
              } else if (
                header ===
                '0020 - LEI of the entity signing the contractual arrangement'
              ) {
                value = row.lei_entity_signing_contractual_arrangement;
              } else {
                value = '';
              }
            } else {
              const key = keys[item.originalIndex];
              value = key ? (row[key] ?? '') : '';
            }

            formattedRow[header] = value ?? '';
          });
          return formattedRow;
        });

        const headerTitles: string[] = [];
        const headerCodes: string[] = [];

        headers.forEach((h: string) => {
          const match = h.match(/^(\d+)\s*-\s*(.*)$/);

          if (match) {
            headerCodes.push(`="${match[1]}"`);
            headerTitles.push(match[2]);
          } else {
            headerCodes.push('');
            headerTitles.push(h);
          }
        });

        const dataRows = formattedData.map((row) =>
          headers.map((h) => row[h] ?? ''),
        );

        const ws = XLSX.utils.aoa_to_sheet([
          headerTitles,
          headerCodes,
          ...dataRows,
        ]);

        let csv = XLSX.utils.sheet_to_csv(ws, { FS: ';' });

        if (csv.charCodeAt(0) === 0xfeff) {
          csv = csv.slice(1);
        }

        files[`reports/${tableNumber}.csv`] = strToU8(csv);

        if (!leiEntityValue) {
          const leiCandidate = excelData.find(
            (item) => item.lei_entity || item.lei,
          );

          if (leiCandidate) {
            leiEntityValue = leiCandidate.lei_entity || leiCandidate.lei;
          }
        }

        filingIndicatorRows.push(`${tableNumber};true`);
      }

      const ws99 = exportToExcel(dataReports99);

      let csv99 = XLSX.utils.sheet_to_csv(ws99, { FS: ';' });

      if (csv99.charCodeAt(0) === 0xfeff) {
        csv99 = csv99.slice(1);
      }

      files['reports/b_99.01.csv'] = strToU8(csv99);

      filingIndicatorRows.push('b_99.01;true');

      files['reports/FilingIndicators.csv'] = strToU8(
        filingIndicatorRows.join('\n'),
      );

      const parametersCsvContent = `name;value
  entityID;rs:${leiEntityValue ?? 'UNKNOWN'}.${reportType}
  refPeriod;${date}
  baseCurrency;iso4217:${selectedCurrency}
  decimalsInteger;0
  decimalsMonetary;-3`;

      files['reports/parameters.csv'] = strToU8(parametersCsvContent);

      files['reports/report.json'] = strToU8(JSON.stringify(dora, null, 2));

      const zipped = zipSync(files, { level: 0 });

      const institutionNumber = 'CCCCCCC';
      const registerName = 'DORAREG_NAME';

      const reportingDate = new Date();

      const yyyy = reportingDate.getFullYear();
      const mm = String(reportingDate.getMonth() + 1).padStart(2, '0');
      const dd = String(reportingDate.getDate()).padStart(2, '0');

      const formattedDate = `${yyyy}${mm}${dd}`;

      const filename = `${institutionNumber}_${formattedDate}_${registerName}.zip`;

      const blob = new Blob([new Uint8Array(zipped)], {
        type: 'application/zip',
      });

      saveAs(blob, filename);
    } catch (error) {
      console.error('Failed to generate CSV zip:', error);
    }
  };

  const handleExportAll = async () => {
    await fetchAllTablesData(queryParams, date);
  };

  const handleClick = () => {
    fetchCurrencies();
    setModalReportTypeVisible(true);
  };

  const handleClickItem = (item: TableItem) => {
    setSelectedItem(item);
  };

  const handleCurrencyChange = (value: string, label: any) => {
    setSelectedCurrency(label.label);
  };

  const handleOkReportType = () => {
    setModalReportTypeVisible(false);
    if (queryParams && date && selectedCurrency) {
      downloadCSV(queryParams, date, selectedReportType, selectedCurrency);
    }
  };

  const handleCancelReportType = () => {
    setModalReportTypeVisible(false);
  };

  const handleClose = () => {
    setSelectedItem(null);
  };
  // const handleXBRLDownload = async () => {
  //     try {
  //         const params = {
  //             entity_name: queryParams.entity_name,
  //             date,
  //         };

  //         const fetchOperations = [
  //             reportingOp.fetchEntityContractualArrangements(params),
  //             reportingOp.fetchBranches(params),
  //             reportingOp.fetchContractualArrangementsLei(params),
  //             reportingOp.fetchContractualArrangementsICT(params),
  //             reportingOp.fetchContractualArrangementsICTUse(params),
  //             reportingOp.fetchRT0101(params),
  //             reportingOp.fetchRT0102(params),
  //             reportingOp.fetchRT0201(params),
  //             reportingOp.fetchRT0202(params),
  //             reportingOp.fetchRT0302(params),
  //             reportingOp.fetchRT0501(params),
  //             reportingOp.fetchRT0502(params),
  //             reportingOp.fetchRT0601(params),
  //             reportingOp.fetchRT0701(params),
  //         ];

  //         const results = await Promise.all(fetchOperations);
  //         let allFields = new Set<string>();
  //         let records: Record<string, any>[] = [];
  //         let titleCounts: Record<string, number> = {};
  //         let fieldCounts: Record<string, number> = {};

  //         results.forEach((apiResponse, responseIndex) => {
  //             apiResponse.forEach((obj: Record<string, any>, idx: number) => {
  //                 Object.keys(obj).forEach(field => {
  //                     allFields.add(field);
  //                     if (fieldCounts[field] > 1) {
  //                         const namespace = `ns${fieldCounts[field]}`;
  //                         field = `${namespace}:${field}`;
  //                     }
  //                 });
  //                 if (!records[idx]) records[idx] = {};

  //                 Object.keys(obj).forEach(key => {
  //                     let sanitizedKey = sanitizeTitleForXML(key);

  //                     if (records[idx].hasOwnProperty(sanitizedKey)) {
  //                         const namespace = `ns${responseIndex}`;
  //                         sanitizedKey = `${namespace}:${sanitizedKey}`;
  //                     }
  //                     records[idx][sanitizedKey] = obj[key] ?? "";

  //                     if (key === 'title') {
  //                         titleCounts[sanitizedKey] = (titleCounts[sanitizedKey] || 0) + 1;
  //                     }
  //                 });
  //             });
  //         });

  //         let transformedRecords = records.map(record => [record]);
  //         const headers = ['B', 'B_99.01.C0010', 'B_99.01.C0020', 'B_99.01.C0030', 'B_99.01.C0040'];
  //         const updatedDummyData = processData(dataReports99);
  //         const finalData = [...secondHeader, ...updatedDummyData];

  //         if (finalData.length > 0) {
  //             transformedRecords = transformedRecords.map((objArray, index) => {
  //                 const obj = { ...objArray[0] };

  //                 if (index < finalData.length) {
  //                     const dataRow = finalData[index];
  //                     headers.forEach((header, i) => {
  //                         obj[header] = dataRow[i] ?? '';
  //                     });
  //                 }

  //                 return [obj];
  //             });
  //         }

  //         while (transformedRecords.length < 34) {
  //             transformedRecords.push([{ }]);
  //         }

  //         const xbrlContent = generateXBRLFile(transformedRecords, titleCounts);
  //         await generateXBRLZip(xbrlContent);

  //         setOpen(false);
  //     } catch (error) {
  //         console.log("Error fetching data or generating XBRL:", error);
  //     }
  // };

  // const generateXBRLFile = (transposedResults: any[], titleCounts: Record<string, number>) => {
  //   let xbrlContent = `<?xml version="1.0" encoding="UTF-8"?>\n`;
  //   xbrlContent += `<xbrl xmlns="http://www.xbrl.org/2003/instance"\n`;
  //   xbrlContent += `  xmlns:xbrli="http://www.xbrl.org/2003/instance"\n`;
  //   xbrlContent += `  xmlns:xbrldt="http://xbrl.org/2005/xbrldt"\n`;
  //   xbrlContent += `  xmlns:link="http://www.xbrl.org/2003/linkbase"\n`;
  //   xbrlContent += `  xmlns:xlink="http://www.w3.org/1999/xlink"\n`;

  //   const namespaces = [
  //     { prefix: "ns1", urn: "http://www.example.com/namespace1" },
  //     { prefix: "ns2", urn: "http://www.example.com/namespace2" },
  //     { prefix: "ns3", urn: "http://www.example.com/namespace3" },
  //     { prefix: "ns4", urn: "http://www.example.com/namespace4" },
  //     { prefix: "ns5", urn: "http://www.example.com/namespace5" },
  //     { prefix: "ns6", urn: "http://www.example.com/namespace6" },
  //     { prefix: "ns7", urn: "http://www.example.com/namespace7" },
  //     { prefix: "ns8", urn: "http://www.example.com/namespace8" },
  //     { prefix: "ns9", urn: "http://www.example.com/namespace9" },
  //     { prefix: "ns10", urn: "http://www.example.com/namespace10" },
  //     { prefix: "ns11", urn: "http://www.example.com/namespace11" },
  //     { prefix: "ns12", urn: "http://www.example.com/namespace12" },
  //     { prefix: "ns13", urn: "http://www.example.com/namespace13" },
  //     { prefix: "ns14", urn: "http://www.example.com/namespace14" },
  //     { prefix: "ns15", urn: "http://www.example.com/namespace15" },
  //   ];

  //   namespaces.forEach(({ prefix, urn }) => {
  //     xbrlContent += `  xmlns:${prefix}="${urn}"\n`;
  //   });

  //   xbrlContent += `>\n`;

  //   const roleRefs = [
  //     { roleURI: "http://www.xbrl.org/2003/role/presentation", id: "presentationRole" },
  //     { roleURI: "http://www.xbrl.org/2003/role/calculation", id: "calculationRole" },
  //     { roleURI: "http://www.xbrl.org/2003/role/dimension", id: "dimensionRole" },
  //   ];

  //   roleRefs.forEach(({ roleURI, id }) => {
  //     xbrlContent += `  <link:roleRef roleURI="${roleURI}" xlink:type="simple" xlink:href="#${id}"/>\n`;
  //   });

  //   xbrlContent += `  <xbrli:context id="c1">\n`;
  //   xbrlContent += `    <xbrli:entity>\n`;
  //   xbrlContent += `      <xbrli:identifier scheme="http://www.example.com/entity">Entity_123</xbrli:identifier>\n`;
  //   xbrlContent += `    </xbrli:entity>\n`;
  //   xbrlContent += `    <xbrli:period>\n`;
  //   xbrlContent += `      <xbrli:instant>2024-12-31</xbrli:instant>\n`;
  //   xbrlContent += `    </xbrli:period>\n`;
  //   xbrlContent += `  </xbrli:context>\n\n`;

  //   xbrlContent += `  <xbrli:unit id="u1">\n`;
  //   xbrlContent += `    <xbrli:measure>iso4217:USD</xbrli:measure>\n`;
  //   xbrlContent += `  </xbrli:unit>\n\n`;

  //   const facts = [
  //     { namespace: "ns1", name: "netIncome", value: "50000" },
  //     { namespace: "ns2", name: "revenue", value: "200000" },
  //     { namespace: "ns3", name: "costOfGoodsSold", value: "150000" },
  //   ];

  //   facts.forEach(({ namespace, name, value }) => {
  //     xbrlContent += `  <${namespace}:${name} contextRef="c1" unitRef="u1">${value}</${namespace}:${name}>\n`;
  //   });

  //   xbrlContent += `  <link:presentationLink xlink:type="extended" xlink:role="http://www.xbrl.org/2003/role/presentation">\n`;
  //   facts.forEach(({ namespace, name }) => {
  //     xbrlContent += `    <link:loc xlink:type="locator" xlink:href="#${namespace}:${name}" xlink:label="${name}"/>\n`;
  //   });
  //   xbrlContent += `  </link:presentationLink>\n\n`;

  //   xbrlContent += `  <link:calculationLink xlink:type="extended" xlink:role="http://www.xbrl.org/2003/role/calculation">\n`;
  //   xbrlContent += `    <link:calculationArc xlink:from="revenue" xlink:to="netIncome" weight="1"/>\n`;
  //   xbrlContent += `    <link:calculationArc xlink:from="costOfGoodsSold" xlink:to="netIncome" weight="-1"/>\n`;
  //   xbrlContent += `  </link:calculationLink>\n\n`;

  //   xbrlContent += `  <link:definitionLink xlink:type="extended" xlink:role="http://www.xbrl.org/2003/role/dimension">\n`;
  //   xbrlContent += `    <link:loc xlink:type="locator" xlink:href="#ns1:netIncome" xlink:label="netIncome"/>\n`;
  //   xbrlContent += `    <link:loc xlink:type="locator" xlink:href="#ns2:revenue" xlink:label="revenue"/>\n`;
  //   xbrlContent += `  </link:definitionLink>\n\n`;

  //   transposedResults.forEach((item) => {
  //     xbrlContent += `  <report>\n`;

  //     item.forEach((data: any) => {
  //       Object.entries(data).forEach(([key, value]) => {
  //         let namespacePrefix = "";
  //         let sanitizedKey = key;

  //         const nsMatch = key.match(/^(ns\d+):?(.+)$/);
  //         if (nsMatch) {
  //           namespacePrefix = nsMatch[1];
  //           sanitizedKey = nsMatch[2];
  //         } else if (titleCounts[key] !== undefined) {
  //           namespacePrefix = `ns${titleCounts[key]}`;
  //           titleCounts[key] -= 1;
  //         }

  //         let sanitizedValue = value === null || value === undefined ? "" : String(value);

  //         if (namespacePrefix) {
  //           xbrlContent += `    <${namespacePrefix}:${sanitizedKey}>${sanitizedValue}</${namespacePrefix}:${sanitizedKey}>\n`;
  //         } else {
  //           xbrlContent += `    <${sanitizedKey}>${sanitizedValue}</${sanitizedKey}>\n`;
  //         }
  //       });
  //     });

  //     xbrlContent += `  </report>\n`;
  //   });

  //   xbrlContent += `</xbrl>\n`;
  //   return xbrlContent;
  // };

  // const sanitizeTitleForXML = (title: string): string => {
  //                 if (!title) return '';
  //                 let sanitizedTitle = title
  //                   .replace(/_/g, ' ')
  //                   .replace(/[()]/g, '')
  //                   .replace(/[^a-zA-Z0-9\s\-.]/g, '')
  //                   .replace(/\s+/g, ' ')
  //                   .trim();

  //                 // Make sure it doesn't start with a number or invalid character
  //                 sanitizedTitle = sanitizedTitle
  //                   .replace(/^(\d)/, '_$1'); // Prepend an underscore if the first character is a number

  //                 sanitizedTitle = sanitizedTitle
  //                   .split(' ')
  //                   .map((word, index) =>
  //                     index === 0
  //                       ? word.charAt(0).toLowerCase() + word.slice(1)
  //                       : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  //                   )
  //                   .join('');

  //                 return sanitizedTitle;
  // };

  // const generateXBRLZip = async (xbrlContent: string) => {
  //   const zip = new JSZip();

  //   zip.file('report.xbrl', xbrlContent);
  //   console.log(xbrlContent, 'xbrlContent');
  //   zip.generateAsync({ type: 'blob' }).then(function(content) {
  //       saveAs(content, 'report.zip');
  //   });
  // }

  const fetchAllTablesData = async (queryLei: any, date: string) => {
    const entityIds = Array.isArray(queryLei?.entityId)
      ? queryLei.entityId
      : queryLei?.entityId
        ? [queryLei.entityId]
        : [];

    if (entityIds.length === 0) {
      console.warn('No entity selected for export');
      return;
    }

    const params = { entityId: entityIds, date };

    const tableMappings = [
      { tableNumber: 'b_01.03', fetchFn: reportingOp.fetchBranches },
      {
        tableNumber: 'b_02.03',
        fetchFn: reportingOp.fetchEntityContractualArrangements,
      },
      {
        tableNumber: 'b_03.01',
        fetchFn: reportingOp.fetchContractualArrangementsLei,
      },
      {
        tableNumber: 'b_03.03',
        fetchFn: reportingOp.fetchContractualArrangementsICT,
      },
      {
        tableNumber: 'b_04.01',
        fetchFn: reportingOp.fetchContractualArrangementsICTUse,
      },
      { tableNumber: 'b_01.01', fetchFn: reportingOp.fetchRT0101 },
      { tableNumber: 'b_01.02', fetchFn: reportingOp.fetchRT0102 },
      { tableNumber: 'b_02.01', fetchFn: reportingOp.fetchRT0201 },
      { tableNumber: 'b_02.02', fetchFn: reportingOp.fetchRT0202 },
      { tableNumber: 'b_03.02', fetchFn: reportingOp.fetchRT0302 },
      { tableNumber: 'b_05.01', fetchFn: reportingOp.fetchRT0501 },
      { tableNumber: 'b_05.02', fetchFn: reportingOp.fetchRT0502 },
      { tableNumber: 'b_06.01', fetchFn: reportingOp.fetchRT0601 },
      { tableNumber: 'b_07.01', fetchFn: reportingOp.fetchRT0701 },
    ];

    try {
      const wb = XLSX.utils.book_new();
      for (const { tableNumber, fetchFn } of tableMappings) {
        let fetchedData: any = null;
        try {
          fetchedData = await fetchFn(params);
        } catch (err) {
          console.log(`Error fetching ${tableNumber}:`, err);
          continue;
        }
        let excelData: any[] = [];
        if (Array.isArray(fetchedData)) {
          excelData = fetchedData;
        } else if (
          fetchedData?.filtered_data &&
          Array.isArray(fetchedData.filtered_data)
        ) {
          excelData = fetchedData.filtered_data.map((item: any) => ({
            ...item,
            entity_name: fetchedData.entity_name,
            date: fetchedData.date || date,
          }));
        } else if (fetchedData?.entities) {
          const allEntities = Object.values(fetchedData.entities)
            .flatMap((entity: any) => {
              if (Array.isArray(entity)) return entity;
              if (
                entity?.filtered_data &&
                typeof entity.filtered_data === 'object'
              ) {
                return Object.values(entity.filtered_data).flat();
              }
              return [];
            })
            .filter(Boolean);
          excelData = allEntities.map((item: any) => ({
            ...item,
            entity_name: item.entity_name || fetchedData.entity_name,
            date: fetchedData.date || date,
          }));
        }

        const mapKey = Object.keys(displayTitleMap || {}).find(
          (k) => k.toLowerCase() === tableNumber.toLowerCase(),
        );
        const rawHeaders =
          (mapKey ? displayTitleMap[mapKey] : displayTitleMap?.[tableNumber]) ||
          [];

        const filteredHeadersWithIndex = rawHeaders
          .map((header: string, index: number) => {
            const trimmed = header.trim();
            if (!trimmed.startsWith('00')) return null;

            const match = trimmed.match(/^(\d+)/);
            const numericPrefix = match
              ? parseInt(match[1], 10)
              : Number.MAX_SAFE_INTEGER;

            return {
              header: trimmed,
              originalIndex: index,
              numericPrefix,
            };
          })
          .filter(Boolean as any);

        filteredHeadersWithIndex.sort(
          (a: any, b: any) => a.numericPrefix - b.numericPrefix,
        );

        const headers = filteredHeadersWithIndex.map((h: any) => h.header);
        const fullHeaders = [...headers];

        if (excelData.length > 0) {
          const formattedData = excelData.map((row: Record<string, any>) => {
            const formattedRow: Record<string, any> = {};

            const keys = Object.keys(row);

            const validIndexes = rawHeaders
              .map((header: string, index: number) =>
                header.trim().startsWith('00') ? index : -1,
              )
              .filter((index: number) => index !== -1);

            validIndexes.forEach((index: number) => {
              const header = rawHeaders[index];

              let value: any;

              if (tableNumber === 'b_03.01') {
                if (
                  header === '0010 - Contractual arrangement reference number'
                ) {
                  value = row.arrangement_reference_number;
                } else if (
                  header ===
                  '0020 - LEI of the entity signing the contractual arrangement'
                ) {
                  value = row.lei_entity_signing_contractual_arrangement;
                } else {
                  value = '';
                }
              } else {
                const key = keys[index];
                value = key ? (row[key] ?? '') : '';
              }

              formattedRow[header] = value ?? '';
            });
            return formattedRow;
          });
          const ws = XLSX.utils.json_to_sheet(formattedData, {
            header: fullHeaders,
          });

          XLSX.utils.book_append_sheet(wb, ws, tableNumber);
        } else {
          console.warn(`No data found for ${tableNumber}`);
        }
      }
      try {
        const sheetData = exportToExcel(dataReports99);
        XLSX.utils.book_append_sheet(wb, sheetData, 'b_99.01');
      } catch (err) {
        console.log('Error fetching b_99.01:', err);
      }

      const fileName = `All_Tables_Data_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(wb, fileName);
    } catch (error) {
      console.log('Failed to fetch/export tables:', error);
    }
  };

  return (
    <Styled.StyledLayout token={token}>
      {(scheme === 'firstTheme' || scheme === 'eighthTheme') && (
        <ReportingHoverStyle />
      )}
      <TitleBar title={t('REPORTING.REPORTING')} />
      <Styled.FilterCard>
        <Styled.FilterGrid>
          <Styled.FilterItem>
            <Styled.FilterLabel theme={scheme}>
              {t('REPORTING.SELECT_ENTITY_MAINTAINING_REGISTER_REPORTING')}
            </Styled.FilterLabel>

            <CustomSelect
              placeholder={t(
                'REPORTING.SELECT_ENTITY_MAINTAINING_REGISTER_PLACEHOLDER',
              )}
              options={entityMaintaining.map((option) => ({
                value: option.id,
                key: option.key,
                label: option.financial_entity_name,
              }))}
              value={idOfSelectedFinancialEntity}
              onChange={handleChangeFinancialEntity}
              allowClear
              filterOption={(input: string, option: { label: string }) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Styled.FilterItem>

          <Styled.FilterItem>
            <Styled.FilterLabel theme={scheme}>
              {t('REPORTING.SELECT_ENTITY_REPORTED')}
            </Styled.FilterLabel>

            <CustomSelect
              placeholder={t('REPORTING.SELECT_ENTITY_PLACEHOLDER')}
              mode="multiple"
              allowClear
              showSearch
              options={
                Array.isArray(entitiesByLei)
                  ? entitiesByLei.flatMap((item) =>
                      item.options.map((opt) => ({
                        value: opt.id,
                        label: opt.name_of_entity,
                      })),
                    )
                  : []
              }
              value={selectedEntities}
              onChange={(values: number[]) => {
                setSelectedEntities(values);

                if (!values || values.length === 0) {
                  handleFilterChangeForReportingsLei([], []);
                } else {
                  const selectedOptions = entitiesByLei
                    .flatMap((item) => item.options)
                    .filter((opt) => values.includes(opt.id));

                  const selectedLabels = selectedOptions.map(
                    (opt) => opt.name_of_entity,
                  );

                  handleFilterChangeForReportingsLei(values, selectedLabels);
                }
              }}
              filterOption={(input: string, option: { label: string }) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Styled.FilterItem>

          <Styled.FilterItem>
            <Styled.FilterLabel theme={scheme}>
              {t('REPORTING.SELECT_REPORTING_DATE')}
            </Styled.FilterLabel>
            <Styled.FullWidthDatePicker>
              <DatePicker onChange={onChangeStartDate} />
            </Styled.FullWidthDatePicker>
          </Styled.FilterItem>
        </Styled.FilterGrid>
      </Styled.FilterCard>
      <Styled.HorizontalLayout theme={scheme}>
        <Styled.GridContainer token={token}>
          <Styled.Container>
            <Styled.SectionTitle token={token}>
              {t('REPORTING.DOWNLOAD_FORMAT_SECTION')}
            </Styled.SectionTitle>
            <Styled.Section section="Format" token={token}>
              <Styled.List>
                <Styled.CardLine theme={scheme}>
                  <Styled.ExportComponent>
                    <Styled.StyledButton
                      type="primary"
                      onClick={handleExportAll}
                      disabled={!queryLei.entityId || !date}
                    >
                      {t('REPORTING.REGISTER_INFORMATION_EXCEL')}
                    </Styled.StyledButton>
                    <Styled.StyledButton
                      type="primary"
                      onClick={handleClick}
                      disabled={!queryLei.entityId || !date}
                    >
                      {t('REPORTING.REGISTER_INFORMATION_CSV')}
                    </Styled.StyledButton>

                    <Modal
                      title={t('REPORTING.FILL_DATA_BEFORE_DOWNLOAD')}
                      visible={modalReportTypeVisble}
                      onOk={handleOkReportType}
                      onCancel={handleCancelReportType}
                      okText={t('REPORTING.DOWNLOAD')}
                      okButtonProps={{
                        disabled: !(queryParams && date && selectedCurrency),
                      }}
                    >
                      {!date && (
                        <Styled.ErrorText>
                          {t('REPORTING.PLEASE_SELECT_REFERENCE_DATE')}
                        </Styled.ErrorText>
                      )}

                      <Styled.SelectWithTopMargin>
                        <CustomSelect
                          placeholder={t('REPORTING.SELECT_BASE_CURRENCY')}
                          size="lg"
                          options={currencies}
                          onChange={handleCurrencyChange}
                          filterOption={(
                            input: string,
                            option: { label: string },
                          ) =>
                            option?.label
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        />
                      </Styled.SelectWithTopMargin>
                    </Modal>
                  </Styled.ExportComponent>
                </Styled.CardLine>
              </Styled.List>
            </Styled.Section>
            <Styled.SectionTitle token={token}>
              {t('REPORTING.INDIVIDUAL_REPORTS_SECTION')}
            </Styled.SectionTitle>
            <Styled.Section section="Reports" token={token}>
              <Styled.List>
                {tableData.map((item) => (
                  <Tooltip
                    key={item.title}
                    title={item.description}
                    placement="right"
                  >
                    <Styled.CardLine
                      theme={scheme}
                      onClick={() => handleClickItem(item)}
                    >
                      <div>
                        <ReportModal
                          title={item.title}
                          tableNumber={item.title}
                          headers={[]}
                          description={item.description}
                        />
                      </div>
                    </Styled.CardLine>
                  </Tooltip>
                ))}
              </Styled.List>
            </Styled.Section>
          </Styled.Container>
        </Styled.GridContainer>
      </Styled.HorizontalLayout>
    </Styled.StyledLayout>
  );
};

export default ReportingLayout;
